import { render } from "./optionbutton2ids.vue?vue&type=template&id=313b744f"
import script from "./optionbutton2ids.vue?vue&type=script&lang=js"
export * from "./optionbutton2ids.vue?vue&type=script&lang=js"

import "./optionbutton2ids.vue?vue&type=style&index=0&id=313b744f&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__